<template>
  <svg
    class="step"
    width="58px"
    height="29px"
    viewBox="1753 1201 58 29"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <g
      id="Three"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
      transform="translate(1753.000000, 1201.000000)"
    >
      <path
        d="M0,0 L47,0 L56.5285516,12.8928447 C57.1845443,13.7804521 57.1849069,15.2190573 56.5285516,16.1071553 L47,29 L0,29 L0,0 Z"
        id="Rectangle-55"
        fill="#4990E2"
      />
      <path
        d="M13.288,18.876 C14.242,20.478 15.916,21.18 17.554,21.18 C19.894,21.18 22.18,19.668 22.18,17.184 C22.18,16.194 21.766,14.862 20.47,14.196 C21.766,13.386 21.874,11.568 21.37,10.308 C20.686,8.616 19.102,8.076 17.536,8.076 C16.096,8.076 14.566,8.85 13.522,10.146 L15.394,11.802 C16.186,10.902 17.752,10.668 18.328,11.568 C18.688,12.108 18.4,13.134 17.572,13.134 L15.664,13.134 L15.664,15.708 L17.644,15.708 C18.562,15.708 19.03,16.284 19.03,16.932 C19.03,17.616 18.292,18.03 17.428,18.03 C16.672,18.03 15.844,17.706 15.376,16.95 L13.288,18.876 Z"
        id="3"
        fill="#FFFFFF"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'StepThreeIcon'
}
</script>
